import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { JhiAlertService } from 'ng-jhipster';
import { Principal } from 'src/app/core';
import { StateStorageService } from 'src/app/core/auth/state-storage.service';
import { TypeOfClient } from 'src/app/shared/model/client.model';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';
import { RoleUtil } from 'src/app/shared/util/role-util';

@Component({
    selector: 'jhi-bulk-no-scopes',
    templateUrl: './bulk-no-scopes.component.html',
    styles: []
})
export class BulkNoScopesComponent implements OnInit {
    istypeOfClientTrader = false;
    isClient: boolean;
    isBroker: boolean;

    constructor(public principal: Principal,
         private activatedRoute: ActivatedRoute,
          private stateStorageService: StateStorageService,
           private jhiAlertService: JhiAlertService,
           private languageChangeService: LanguageChangeService 
           ) { 
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
           }

    ngOnInit() {
        this.showButtons();
        this.principal.identity(true).then(account => {
            console.log(account);
            if (account.typeOfClient) {
                this.clientType(account.typeOfClient);
            } else {
                const typeOfClient = this.stateStorageService.getTypeOfClient();
                this.clientType(typeOfClient);
            }
        });
        this.jhiAlertService.error(null, null, null);
    }

    clientType(typeOfClient) {
        if (typeOfClient === TypeOfClient.TRADER) {
            this.istypeOfClientTrader = true;
        } else {
            this.istypeOfClientTrader = false;
        }
    }

    showButtons() {
        this.isClient = false;
        if (this.principal.hasAnyAuthorityDirect(RoleUtil.ClientAuthorities)) {
            this.isClient = true;
        }

        this.isBroker = false;
        if (this.principal.hasAnyAuthorityDirect(RoleUtil.BrokerUnderwriteInsurerAuthorities)) {
            this.isBroker = true;
        }
    }
}
